import { createContext, useCallback, useContext, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X, Image as ImageIcon, Download } from "lucide-react";
import { resolveUploadUrl } from "@/lib/api";

const InvitationViewerContext = createContext({
  openInvitation: (_url) => {},
});

export const InvitationViewerProvider = ({ children }) => {
  const [url, setUrl] = useState(null);

  const openInvitation = useCallback((u) => {
    if (!u) return;
    setUrl(u);
  }, []);

  const resolved = url ? resolveUploadUrl(url) : "";

  return (
    <InvitationViewerContext.Provider value={{ openInvitation }}>
      {children}
      <Dialog open={!!url} onOpenChange={(o) => !o && setUrl(null)}>
        <DialogContent
          className="max-w-3xl bg-[#F9F6F0] border-stone-200 max-h-[92vh] overflow-y-auto"
          data-testid="invitation-viewer"
        >
          <DialogHeader className="text-left">
            <div className="text-[11px] uppercase tracking-[0.2em] text-[#8A252C]/80 font-bold">Davetiye</div>
            <DialogTitle className="font-display text-2xl text-[#1F2937] flex items-center gap-2">
              <ImageIcon className="w-5 h-5 text-[#8A252C]" />
              Etkinlik Davetiyesi
            </DialogTitle>
          </DialogHeader>

          <div className="py-2">
            {resolved && (
              <img
                src={resolved}
                alt="Davetiye"
                data-testid="invitation-viewer-image"
                className="w-full rounded-2xl bg-white shadow-sm max-h-[65vh] object-contain mx-auto"
              />
            )}
          </div>

          <div className="flex flex-col sm:flex-row gap-2 justify-end pt-2">
            <a
              href={resolved}
              download
              className="inline-flex items-center gap-2 h-11 px-4 rounded-xl border border-stone-300 text-[#1F2937] hover:bg-stone-100 text-sm font-medium"
              data-testid="invitation-download-btn"
            >
              <Download className="w-4 h-4" />
              İndir
            </a>
            <Button
              onClick={() => setUrl(null)}
              data-testid="invitation-close-btn"
              className="bg-[#8A252C] hover:bg-[#6f1d24] text-white h-11 gap-2 rounded-xl"
            >
              <X className="w-4 h-4" />
              Davetiyeyi Kapat
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </InvitationViewerContext.Provider>
  );
};

export const useInvitationViewer = () => useContext(InvitationViewerContext);
